import React from "react"
import Cabecalho from "../Cabecalho"
import { RespostasPersonalizadasIzzaComponent } from "./components/RespostasPersonalizadasIzzaComponent"

export function RespostasPersonalizadasIzzaPage() {
    return (
        <>
            <Cabecalho pagina="Respostas Personalizadas Izza" />
            <RespostasPersonalizadasIzzaComponent />
        </>
    )
}
